import { connect, useSelector } from 'react-redux'
import React, { useState } from 'react'
import { getModel } from 'react-redux-form'
import { jt, t } from 'ttag'

import {
  loadSpResults,
  loadSubsequentSpResults
} from '../../../actions/assessments/skillsProfiler'
import SearchQueryHandlerComponent from '../../../components/search/SearchQueryHandlerComponent'
import { useTitleChange } from '../../../util/hooks'

const SkillsProfilerResults = props => {
  const pageTitle = t`Skills Profiler Results`

  useTitleChange(pageTitle)

  const [filterModel, setFilterModel] = useState({})
  const loadFunction = loadSpResults
  const loadMoreFunction = loadSubsequentSpResults(filterModel)
  const strongLink = (
    <span className="occupation-link strong-match">{t`this color and marked with an *`}</span>
  )
  const searchRequest = useSelector(state => state.assessments.skillsProfiler.results)

  return [
    <div className="container">
      <p>
        {jt`Your skills profile returned the following occupations. Occupations in ${strongLink} represent stronger matches. 
           You can compare up to four occupations by selecting the boxes to the left of the desired occupations and then clicking 
           on the Compare Selected button at the bottom of the page. You can also filter occupation lists by Job Zone (preparation required),
            salary, and more to help you refine your search.`}
      </p>
    </div>,
    <SearchQueryHandlerComponent
      loadFunction={loadFunction}
      loadMoreFunction={loadMoreFunction}
      setFilterModel={setFilterModel}
      searchRequest={searchRequest}
      {...props}
    />
  ]
}

export default SkillsProfilerResults
